import React, { ReactNode } from 'react';
import { Heading, HeadingHierarchy } from '../../../../components/Heading/Heading';
import { CustomErrorTypeMessages, DefaultStatusMessages, StatusMessages } from '../../../partials/StatusMessages';
import { FetchState } from '../../../../../hooks/reducers/useFetchReducer';
import { AxiosError, AxiosResponse } from 'axios';
import { SonResponseError } from '../../../types/SonResponseError';
import { ButtonRefType } from '../../../../../components/molecules/Btn/Btn';
import { AcceptDeclineFormButtons } from './AcceptDeclineFormButtons';

export type AcceptDeclineFormTemplate = DefaultStatusMessages &
  CustomErrorTypeMessages & {
    headline: string | ReactNode;
    hierarchy?: HeadingHierarchy;
    fetchState: FetchState<AxiosResponse<any>, AxiosError<SonResponseError>>;
    onDecline?: () => void;
    acceptButtonRef?: ButtonRefType;
    declineButtonRef?: ButtonRefType;
  };

export function AcceptDeclineFormTemplate({
  headline,
  fetchState,
  messageSuccess,
  messageForward,
  messageSending,
  messageFail,
  customErrorTypeMessages,
  hierarchy = 3,
  onDecline,
  acceptButtonRef,
  declineButtonRef,
}: AcceptDeclineFormTemplate) {
  return (
    <>
      <div className="accept-decline-form">
        <Heading hierarchy={hierarchy} className="accept-decline-form__headline font-regular-15-23">
          {headline}
        </Heading>
        <AcceptDeclineFormButtons
          acceptButtonRef={acceptButtonRef}
          declineButtonRef={declineButtonRef}
          buttonAriaDisabled={fetchState.type === 'success' || fetchState.type === 'loading'}
          onDecline={onDecline}
        />
      </div>
      <StatusMessages
        messageSuccess={messageSuccess}
        messageForward={messageForward}
        messageSending={messageSending}
        messageFail={messageFail}
        customErrorTypeMessages={customErrorTypeMessages}
        fetchState={fetchState}
      />
    </>
  );
}
